import React from 'react';
import { clsx } from 'clsx';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  error,
  helperText,
  className,
  ...props
}) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">
          {label}
        </label>
      )}
      <textarea
        className={clsx(
          'block w-full rounded-xl border-0 ring-1 ring-gray-200 bg-gray-50 py-3.5 shadow-sm transition-all duration-200',
          'focus:ring-2 focus:ring-blue-500 focus:bg-white',
          'hover:ring-gray-300 hover:bg-white',
          'placeholder:text-gray-400 placeholder:italic text-gray-900 font-medium',
          'disabled:bg-gray-100 disabled:cursor-not-allowed',
          error && 'ring-red-500 focus:ring-red-500 bg-red-50/30',
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-1 text-sm text-gray-500">{helperText}</p>
      )}
    </div>
  );
};





